import { render, staticRenderFns } from "./ThanksModal.vue.html?vue&type=template&id=cfb87466&scoped=true&"
import script from "./ThanksModal.component.js?vue&type=script&lang=vueJs&"
export * from "./ThanksModal.component.js?vue&type=script&lang=vueJs&"
import style0 from "./ThanksModal.scoped.scss?vue&type=style&index=0&id=cfb87466&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb87466",
  null
  
)

export default component.exports